module.exports = __webpack_public_path__ + "img/login-landscape.0a26efb2.svg";